import React from 'react'
import { ExportContainerDetail } from '../../types/container'
import { Modal } from '../ui/Modal/Modal'
import { ModalHeader } from '../ui/Modal/ModalHeader'
import { ModalBody } from '../ui/Modal/ModalBody'
import { Table } from '../ui/Table/Table'
import { TableHeader } from '../ui/Table/TableHeader'
import { TableRow } from '../ui/Table/TableRow'
import { TableCell } from '../ui/Table/TableCell'

export interface ExportDetailModalProps {
  detail: ExportContainerDetail | null
  isOpen: boolean
  onClose: () => void
}

export const ExportDetailModal: React.FC<ExportDetailModalProps> = ({ detail, isOpen, onClose }) => {
  if (!detail) return null

  return (
    <Modal isOpen={isOpen} onClose={onClose} maxWidth="max-w-6xl">
      <ModalHeader
        title={`Export: ${detail.containerNumber}`}
        onClose={onClose}
      />
      <ModalBody>
        <Table>
          <TableHeader columns={7}>
            <TableCell>Laad/los locatie</TableCell>
            <TableCell>Datum</TableCell>
            <TableCell>Uur</TableCell>
            <TableCell>Klantcode</TableCell>
            <TableCell>Kaai</TableCell>
            <TableCell>Naam boot</TableCell>
            <TableCell>Closing date</TableCell>
          </TableHeader>

          <TableRow columns={7}>
            <TableCell>{detail.laadLosLocatie}</TableCell>
            <TableCell>{detail.datum}</TableCell>
            <TableCell>{detail.uur}</TableCell>
            <TableCell>{detail.klantcode}</TableCell>
            <TableCell>{detail.kaai}</TableCell>
            <TableCell>{detail.naamBoot || '-'}</TableCell>
            <TableCell>{detail.closingDate || '-'}</TableCell>
          </TableRow>
        </Table>
      </ModalBody>
    </Modal>
  )
}
